// src/components/Navbar.js
import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { AuthContext } from '../context/AuthContext';
import { jwtDecode } from 'jwt-decode';


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleLogout = () => {
    logout();
    navigate('/login');
    setIsOpen(false); // Fermer le menu après déconnexion
  };

  const handleLinkClick = () => {
    setIsOpen(false); // Fermer le menu après un clic sur un lien
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-toggle" onClick={toggleMenu}>
          <span className="navbar-hamburger">&#9776;</span>
        </div>
        <ul className={`navbar-links ${isOpen ? 'open' : ''}`}>
          <li><Link to="/" onClick={handleLinkClick}>Accueil</Link></li>
          <li><Link to="/rooms" onClick={handleLinkClick}>Les Salles</Link></li>

          {user && user.role === 'view' && (
            <>
              <li><Link to="/booking-calendar" onClick={handleLinkClick}>Calendrier</Link></li>
              <li><button onClick={handleLogout}>Déconnexion</button></li>
            </>
          )}
          {user && user.role === 'admin' && (
            <>
              <li><Link to="/booking-calendar" onClick={handleLinkClick}>Calendrier</Link></li>
              <li><Link to="/manage-slots" onClick={handleLinkClick}>Gérer les créneaux</Link></li>
              <li><Link to="/bookings" onClick={handleLinkClick}>Réservations</Link></li>
              <li><Link to="/users" onClick={handleLinkClick}>Utilisateurs</Link></li>
              <li><button onClick={handleLogout}>Déconnexion</button></li>
            </>
          )}
          {user && user.role === 'client' && (
            <>
              <li><Link to="/booking-calendar" onClick={handleLinkClick}>Calendrier</Link></li>
              <li><Link to="/bookings" onClick={handleLinkClick}>Réservations</Link></li>
              <li><button onClick={handleLogout}>Déconnexion</button></li>
            </>
          )}
          {!user && (
            <>
              <li><Link to="/login" onClick={handleLinkClick}>Connexion</Link></li>
              <li><Link to="/register" onClick={handleLinkClick}>Inscription</Link></li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;